import { supabase } from '@/integrations/supabase/client';

const API_BASE = () =>
  (import.meta.env.VITE_SUPABASE_URL as string) ?? 'https://beta.crm-api.primetecia.com.br/api';

export async function postConversationAction<T = unknown>(path: string, body: Record<string, unknown> = {}): Promise<T> {
  const { data: { session } } = await supabase.auth.getSession();
  const response = await fetch(`${API_BASE()}${path}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session?.access_token ?? ''}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ origem: 'humano_inbox', ...body }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.success === false) {
    throw new Error(payload?.error || payload?.erro_detalhe || `HTTP ${response.status}`);
  }
  return payload?.data as T;
}

export type PermissaoConversa = {
  assumir: { permitido: boolean; mensagem?: string; codigo?: string };
  enviar: { permitido: boolean; mensagem?: string; codigo?: string };
};

export async function getConversationPermission(conversationId: string): Promise<PermissaoConversa> {
  const { data: { session } } = await supabase.auth.getSession();
  const response = await fetch(`${API_BASE()}/v1/whatsapp/conversas/${conversationId}/permissao`, {
    headers: { Authorization: `Bearer ${session?.access_token ?? ''}` },
  });
  const payload = await response.json();
  if (!response.ok || payload.success !== true) throw new Error(payload.error || 'Não foi possível validar a permissão.');
  return payload;
}
